<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: "App",
        data() {
            return {}
        },
        created() {
            let that = this;
            fetch('/config.json')
                .then(response => response.json())
                .then(config => {
                    that.$store.state.year = config.year;
                    that.$store.state.downloadTime = config.downloadTime;
                    that.$store.state.testTime = config.testTime;
                })
                .catch(error => {
                    console.error('加载配置文件失败:', error);
                });
        }
    }
</script>

<style lang="scss">
    html, body {
        margin: 0;
        padding: 0;
        height: 100%;
    }

    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        /*text-align: center;*/
        color: #2c3e50;
        height: 100%;
    }

    // 退出登录messageBox样式
    .el-message-box {
        background: #ffffff;
        border-radius: 4px;
        max-width: 420px !important;
        min-width: 320px !important;
        width: 80% !important;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);

        .el-message-box__header {
            .el-message-box__headerbtn:hover {
                .el-message-box__close {
                    &::before {
                        color: var(--color) !important;
                    }
                }
            }

            .el-message-box__headerbtn:hover {
                &::before {
                    color: var(--color) !important;
                }
            }
        }

        .el-message-box__btns {
            .el-button {
                border-color: #cccccc;
                background-color: #ffffff;
                color: #999999;
            }

            .el-button--primary {
                color: #ffffff;
                border-color: var(--color);
                background-color: var(--color);
            }
        }
    }

    // 下拉框样式
    .el-select-dropdown__item {
        height: 40px;
        line-height: 40px;
    }

    .el-select-dropdown__item.selected {
        color: var(--color) !important;
    }

    .el-select-dropdown .scroll-opacity.el-scrollbar .el-scrollbar__bar.is-vertical {
        opacity: 1; //改为0不显示滚动条
    }

</style>
